import { lazy } from 'react';

export const PropertyCatalogPageAsync = lazy(
    () => import('./PropertyCatalogPage'),
);
